export type ABTestGroupName = keyof typeof AB_TEST_GROUPS;
export type ABTestKey = keyof typeof AB_TESTS;
export type ABTestProps = {
    gaDimension: string;
    // String type uses for backward compatibility. In the future in ideal world this prop should have type only from AB_TESTS keys
    gaTestName: ABTestKey | string;
    unleashKey: string;
    hardApplyParam?: string;
};
export type ABTestData = ABTestProps & {
    groupActiveTest?: ABTestKey | '';
};

type ABTestGroups = {
    [key in ABTestGroupName]: Array<ABTestKey>;
};

type ABTests = {
    [key in ABTestKey]: ABTestProps;
};

enum AB_TEST_GROUPS {
    MaterialPageDesktopABTestsGroup = 'Group for AB tests on the material page for the desktop view',
    MaterialPageDesktopABTestsGroup2 = 'The 2nd group for AB tests on the material page for the desktop view',
    MaterialPageMobileABTestsGroup = 'Group for AB tests on the material page for the mobile view'
}

enum AB_TESTS {
    SMB = 'Show more buttons on the material page',
    RANK4 = 'Improve Elastic search ranking "testSegment: 28" 33% for each',
    AF = 'Author Filters on elastic-indexer',
    SS25 = 'Spring Sale Hero banner 2025',
    SS = 'Shorter sections on the material page (description, reviews, materials in bundle)',
    SSPB = 'Spring Sale Price Box label',
    MGP = 'Mobile galleries (vertical, carousel)',
    MFSM = 'Move favorites and share buttons mobile',
    MFSD = 'Move favorites and share buttons desktop',
    MRW = 'Material rating widget'
}

export const EXISTED_AB_TEST_GROUPS: ABTestGroups = {
    MaterialPageDesktopABTestsGroup: [],
    MaterialPageDesktopABTestsGroup2: ['SMB', 'SS', 'MFSD', 'MRW'],
    MaterialPageMobileABTestsGroup: ['MGP', 'MFSM']
};

export const EXISTED_AB_TESTS: ABTests = {
    SMB: {
        gaDimension: 'testSegment3',
        gaTestName: 'SMB',
        unleashKey: 'ShowMoreBtn'
    },
    RANK4: {
        gaDimension: 'testSegment12',
        gaTestName: 'RANK4',
        hardApplyParam: 'RANK4',
        unleashKey: 'DetectumElasticRANKs4'
    },
    AF: {
        gaDimension: 'testSegment7',
        gaTestName: 'AF',
        hardApplyParam: 'AuthorFilters',
        unleashKey: 'AuthorFilters'
    },
    SS25: {
        gaDimension: 'testSegment11',
        gaTestName: 'SS25',
        hardApplyParam: 'Sale',
        unleashKey: 'SpringSale2025'
    },
    SS: {
        gaDimension: 'testSegment3',
        gaTestName: 'SS',
        unleashKey: 'ShorterSections'
    },
    SSPB: {
        gaDimension: 'testSegment3',
        gaTestName: 'SSPB',
        unleashKey: 'SpringSalePriceBox'
    },
    MGP: {
        gaDimension: 'testSegment1',
        gaTestName: 'MGP',
        unleashKey: 'MobileGalleryPreviews'
    },
    MFSM: {
        gaDimension: 'testSegment6',
        gaTestName: 'MFSM',
        unleashKey: 'MoveFavShareMobile'
    },
    MFSD: {
        gaDimension: 'testSegment6',
        gaTestName: 'MFSD',
        unleashKey: 'MoveFavShareDesktop'
    },
    MRW: {
        gaDimension: 'testSegment1',
        gaTestName: 'MRW',
        unleashKey: 'MaterialRatingSection'
    },
};
